import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" updated="June 2026" testid="refund-page">
      <p>This policy explains how billing, trials, cancellations, and refunds work for BidMatchAI subscriptions, operated by <strong>KNA, Sole Proprietor</strong>. It is part of our <a href="/terms">Terms of Service</a>.</p>

      <h2>1. Free Trial</h2>
      <p>New subscriptions may include a <strong>5-day free trial</strong> that requires a valid payment method. You will not be charged during the trial. <strong>If you do not cancel before the trial ends, your subscription automatically converts to a paid plan</strong> and your payment method is charged the then-current price for your selected plan.</p>

      <h2>2. Recurring Billing</h2>
      <p>Paid plans are billed in advance on a recurring basis (monthly or annually, as selected) and renew automatically until cancelled. All payments are processed securely by Stripe.</p>

      <h2>3. How to Cancel</h2>
      <p>You can cancel at any time from <strong>Dashboard → Billing</strong>. When you cancel, your plan remains active until the end of the current billing period, after which it will not renew. To cancel before your free trial converts, cancel any time before the 5-day trial ends.</p>

      <h2>4. Refunds</h2>
      <ul>
        <li><strong>Trials:</strong> Because the trial is free, no charge occurs unless it converts. If you forget to cancel and are charged, contact us within <strong>7 days</strong> of the charge and we will, at our discretion, consider a refund of that initial charge.</li>
        <li><strong>Monthly plans:</strong> Payments are generally non-refundable for the current period, but you will not be billed again after you cancel.</li>
        <li><strong>Annual plans:</strong> Annual payments are generally non-refundable. If you believe your situation warrants an exception, contact us.</li>
        <li><strong>Duplicate or erroneous charges:</strong> will be refunded promptly upon verification.</li>
      </ul>
      <p>All refund requests are reviewed on a case-by-case basis. Approved refunds are issued to the original payment method via Stripe and may take several business days to appear.</p>

      <h2>5. Price Changes</h2>
      <p>We may change subscription prices. Any change will apply to future billing periods and, where required, we will give you advance notice. Your continued use after a price change takes effect constitutes acceptance.</p>

      <h2>6. How to Request a Refund</h2>
      <p>Email <a href="mailto:support@bidmatchai.io">support@bidmatchai.io</a> from the address on your account with your name and the approximate charge date. We aim to respond within a few business days.</p>
    </LegalLayout>
  );
}
